export const uploadButtonContainer = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
};

export const uploadButton = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "92px",
  height: "25px",
  borderRadius: "2px",
  border: "1px solid #767676",
  color: "#171A1F",
  fontFamily: "Roboto",
  fontSize: "14px",
  fontWeight: 400,
  marginRight: "4px",
  backgroundColor: "rgb(239, 239, 239,1)",
  cursor: "pointer",
};
